export function toSanitiseString(input: string) {
  const sanitisedStr = input.replace(/\s+/g, ' ').trim()
  return sanitisedStr
}

export const minLengthString = (minLength: number) => (value: string) =>
  !value || value.trim().length < minLength ? `Field must have at least ${minLength} characters` : undefined

export const capitalizeFirstLetter = (item: string) => item.charAt(0).toUpperCase() + item.slice(1)

interface DOMParserLike {
  parseFromString(input: string, mimeType: string): { body: { textContent: string | null } }
}

/**
 * Strips html tag in a string.
 */
export const stripHtmlTags = (htmlString: string) => {
  // Check for DOMParser safely, without referencing "window"
  const DOMParserClass = (globalThis as { DOMParser?: new () => DOMParserLike }).DOMParser

  if (DOMParserClass) {
    // Browser environment — safe to use DOMParser
    const parser = new DOMParserClass()
    const doc = parser.parseFromString(htmlString, 'text/html')
    return doc.body.textContent?.trim() || ''
  }

  // Node.js / SSR fallback — use regex
  return htmlString.replace(/<[^>]*>/g, '')
}

/**
 * Truncates a string and adds an ellipsis if it exceeds the specified maximum length.
 */
export const truncateWithEllipsis = (str: string, maxLength: number) => {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + '…' // Use a single ellipsis character
  }
  return str // No truncation needed
}
